import { render, staticRenderFns } from "./CompanyHero.vue?vue&type=template&id=bc7ecc00&scoped=true"
import script from "./CompanyHero.vue?vue&type=script&lang=js"
export * from "./CompanyHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7ecc00",
  null
  
)

export default component.exports